import { useState } from 'react';

export const DashboardHeader = ({ title, subtitle, onMenu, actions = null }) => (
  <header className="dashboard-header">
    <div className="dashboard-heading">
      <button className="mobile-menu-trigger" onClick={onMenu} aria-label="Ouvrir le menu" type="button">
        <i className="fa-solid fa-bars" />
      </button>
      <div className="dashboard-titlewrap">
        <span className="dashboard-kicker">Artist Dashboard <i /> {new Date().getFullYear()}</span>
        <h1>{title}</h1>
        {subtitle && <p className="dashboard-subtitle">{subtitle}</p>}
      </div>
    </div>
    <div className="dashboard-head-actions">
      {actions}
      <button aria-label="Notifications" className="icon-button" type="button">
        <i className="fa-regular fa-bell" />
      </button>
    </div>
  </header>
);

export const ReleaseCover = ({ title, color = 'from-[#d2a49b] to-[#4b1c27]', image = null, onPlay = null }) => {
  // Sans Tailwind : gradient via style inline, classes DNA conservées
  const gradient = color.includes('#')
    ? (() => {
        const m = color.match(/#[0-9a-fA-F]{3,8}/g) || [];
        return m.length >= 2 ? `linear-gradient(135deg, ${m[0]}, ${m[1]})` : 'linear-gradient(135deg,#d2a49b,#4b1c27)';
      })()
    : 'linear-gradient(135deg,#d2a49b,#4b1c27)';
  return (
    <div className="release-cover" style={{ background: image ? `url(${image}) center/cover` : gradient }}>
      <div className="cover-noise" />
      <span className="cover-label">PASS’IO</span>
      <span className="cover-title">{title}</span>
      {onPlay && (
        <button className="cover-play" onClick={onPlay} aria-label={`Voir ${title}`}>
          <i className="fa-solid fa-play" />
        </button>
      )}
    </div>
  );
};

export const useShareToast = () => {
  const [msg, setMsg] = useState('');
  const show = (m) => {
    setMsg(m);
    setTimeout(() => setMsg(''), 3000);
  };
  const node = msg ? (
    <div style={{
      position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
      background: '#189b69', color: '#fff', padding: '10px 20px', borderRadius: 10, zIndex: 1000,
    }}>{msg}</div>
  ) : null;
  return [show, node];
};

export default DashboardHeader;
